import { Box } from "@mui/material";
import { SnackbarContent } from "notistack";
import React from "react";

const CustomSnackbar = React.forwardRef((props, ref) => {
  const {
    // You have access to notistack props and options 👇🏼
    id,
    message,
    action,
    onClose,
    variant,
    // as well as your own custom props 👇🏼
    allowClose,
    ...other
  } = props;

  const classes = {
    success: {
      backgroundColor: "#1D192B",
    },
    error: {
      backgroundColor: "#B3261E",
    },
  };

  const rootStyle = {
    position: "relative",
    padding: "8px 16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    lineHeight: "20px",
    fontSize: "14px",
    borderRadius: "10px",
    maxWidth: "720px",
    minWidth: "auto",
    flexWrap: "nowrap",
    color: "#fff",
  };

  const icons = {
    default: <></>,
    success: (
      <i
        className="meta-crm-icon-ic_check font-size-16"
        style={{ marginRight: "8px" }}
      />
    ),
    error: (
      <i
        className="meta-crm-icon-ic_alert font-size-16"
        style={{ marginRight: "8px" }}
      />
    ),
  };

  return (
    <SnackbarContent
      ref={ref}
      role="alert"
      {...other}
      style={{ minWidth: "unset", ...rootStyle, ...classes[variant] }}
    >
      <Box display="flex" alignItems={"center"}>
        {icons[variant]}
        <Box>{message}</Box>
      </Box>
      <Box display="flex" alignItems={"center"} flexShrink={0}>
        {action}
        {allowClose && (
          <i
            className="meta-crm-icon-ic_cancel font-size-16"
            style={{ marginLeft: "8px", cursor: "pointer" }}
            onClick={onClose}
          />
        )}
      </Box>
    </SnackbarContent>
  );
});

export default CustomSnackbar;
